import { render, staticRenderFns } from "./ConnectLeagueOfLegendsAccountForm.vue?vue&type=template&id=000ce588&scoped=true&"
import script from "./ConnectLeagueOfLegendsAccountForm.vue?vue&type=script&lang=ts&"
export * from "./ConnectLeagueOfLegendsAccountForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000ce588",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
